// Dependency-free horizontal bar chart. `max` sets the 100% width.
export default function BarChart({ title, rows, unit = "", max, source }) {
  const m = max || Math.max(...rows.map((r) => r.v));
  return (
    <figure className="bg-white border border-slate-200 rounded-md p-7 h-full flex flex-col">
      <figcaption className="hp-h3">{title}</figcaption>
      <ul className="mt-6 space-y-4 flex-1">
        {rows.map((r) => (
          <li key={r.l}>
            <div className="flex justify-between text-sm font-semibold text-slate-700"><span>{r.l}</span><span>{r.show || `${r.v}${unit}`}</span></div>
            <div className="mt-1.5 h-3 rounded-full bg-slate-100 overflow-hidden" role="img" aria-label={`${r.l}: ${r.show || r.v + unit}`}>
              <div className="h-full rounded-full bg-[var(--hop-brand)]" style={{ width: `${Math.max(3, (r.v / m) * 100)}%` }} />
            </div>
          </li>
        ))}
      </ul>
      <p className="mt-5 text-xs text-slate-500">Source: {source}</p>
    </figure>
  );
}
